import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import React, { useEffect, useState } from "react";
/* Nav */
import Header from "./components/Navigation-bar";
/* Pages */
import Home from "./pages/homepage";
import Contact from "./pages/contact";

import Services from "./pages/services/services";
import TaxAdvisory from "./pages/services/tax-advisory";
import RiskAdvisory from "./pages/services/risk-advisory";
import AuditAssurance from "./pages/services/audit-assurance";
import MergersAcqusitions from "./pages/services/mergers-acquisitions";

import About from "./pages/about/about";
import Team from "./pages/about/team";
import Mission from "./pages/about/mission";
import Philosophy from "./pages/about/philosophy";

import Career from "./pages/career";

import Insights from "./pages/insights/insights";
import News from "./pages/insights/news";
import Updates from "./pages/insights/updates";
import UsefulLinks from "./pages/insights/useful-links";

/* Tranisition Pages */
import LoadingPage from "./components/LoadingPage";
import TransitionRouter from "./components/Transition";

/* Post Renderer */
import NewsPostPage from "./components/NewsPostPage";
import UpdatePostPage from "./components/UpdatePostPage";

/* Styles */
import "./App.css";
import "./styles/styles.css";

function App() {
  const [loading, setLoading] = useState(true);

  /* For changing themes */
  function ThemeHandler() {
    const location = useLocation();

    useEffect(() => {
      if (
        location.pathname === "/services" ||
        location.pathname.startsWith("/services/")
      ) {
        document.body.classList.add("services-theme");
        document.body.classList.remove("insights-theme");
        console.log("Service theme");
      } else if (
        location.pathname === "/insights" ||
        location.pathname.startsWith("/insights/")
      ) {
        document.body.classList.add("insights-theme");
        document.body.classList.remove("services-theme");
        console.log("Insight theme");
      } else {
        document.body.classList.remove("services-theme");
        document.body.classList.remove("insights-theme");
        console.log("Base theme");
      }
    }, [location.pathname]);

    return null; 
  }

  /* Loading Page */
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <ThemeHandler />
      {loading ? (
        <LoadingPage />
      ) : (
        <>
          {/* Header*/}
          <Header />
          <div className="main-content">
            <Routes>
              <Route element={<TransitionRouter />}>
                {/* Main Pages */}
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/contact" element={<Contact />} />
                {/* Services Routes*/}
                <Route
                  path="/services/tax-advisory"
                  element={<TaxAdvisory />}
                />
                <Route
                  path="/services/risk-advisory"
                  element={<RiskAdvisory />}
                />
                <Route
                  path="/services/mergers-acquisitions"
                  element={<MergersAcqusitions />}
                />
                <Route
                  path="/services/audit-assurance"
                  element={<AuditAssurance />}
                />
                {/* About Us Routes */}
                <Route path="/about/mission" element={<Mission />} />
                <Route path="/about/philosophy" element={<Philosophy />} />
                <Route path="/about/team" element={<Team />} />

                <Route path="/career" element={<Career />} />

                {/* Insights Routes */}
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/updates" element={<Updates />} />
                <Route path="/insights/updates/:slug" element={<UpdatePostPage />} />
                <Route path="/insights/news" element={<News />} />
                <Route path="/insights/news/:slug" element={<NewsPostPage />}/>
                <Route
                  path="/insights/useful-links"
                  element={<UsefulLinks />}
                />
              </Route>
            </Routes>
          </div>
        </>
      )}
    </Router>
  );
}

export default App;
